import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import ReactGA from 'react-ga';

ReactGA.initialize('UA-77055530-10');

class Ga extends React.Component {
  static propTypes = {
    location: PropTypes.shape().isRequired,
    children: PropTypes.node.isRequired,
    pace: PropTypes.shape().isRequired
  }

  componentWillReceiveProps({ location: { pathname } }) {
    const { pace } = this.props;
    if (this.props.location.pathname !== pathname) {
      if (!pathname.match(/test|tape/)) pace.restart();
      window.scrollTo(0, 0);
    }
  }

  componentDidUpdate(prevProps) {
    if (location !== prevProps.location) {
      ReactGA.pageview(location.pathname);
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(Ga);



// WEBPACK FOOTER //
// ./app/components/Ga.js